import Link from "next/link"
import type { FC } from "react"

import Logo from "./icons/Logo"
import UbiqButton, { UbiqButtonType } from "./UbiqButton"

interface HeaderProps {
  logoColor: string
  onClick?: () => void
  isButton?: boolean
  className?: string
  hideShopLink?: boolean
}

const Header: FC<HeaderProps> = ({
  logoColor,
  onClick,
  isButton = false,
  className = "",
  hideShopLink = false,
}) => {
  return (
    <div className={className}>
      <Link href="/">
        <Logo color={logoColor} fillStyle={{ transition: "fill 1s ease" }} />
      </Link>
      <div className="flex items-center gap-8">
        <UbiqButton
          buttonType={UbiqButtonType.LIGHT}
          onClick={onClick}
          styles={`uppercase w-[123px] hidden md:flex font-mono ${
            isButton ? "opacity-1" : "opacity-0 pointer-events-none"
          } transition-opacity duration-1000 ease-linear`}
          title="Join us"
        />
        {!hideShopLink && (
          <Link
            className="font-mono font-bold text-[13px] uppercase transition-colors duration-1000 ease-linear"
            href="/fleamarket"
            style={{ color: logoColor }}
          >
            Shop
          </Link>
        )}
      </div>
    </div>
  )
}

export default Header
